import * as React from 'react'
import BaseCombobox, { BaseComboboxProps } from './BaseCombobox'
import { useTranslation } from 'react-i18next'

export type EnumComboboxProps<E> = Omit<BaseComboboxProps<E>, 'getEntityLabel' | 'getEntityValue'> & {
    labelKeyPrefix: string
}

export default function EnumCombobox<E>(props: EnumComboboxProps<E>) {
    const { t: translate } = useTranslation()

    return (
        <BaseCombobox<E>
            entities={[...props.entities]}
            getEntityLabel={(entity: E) =>
                translate(`${props.labelKeyPrefix}.${entity.toString().toLowerCase().replaceAll(/[-_]/g, '')}`)
            }
            getEntityValue={(entity: E) => entity?.toString()}
            {...props}
        />
    )
}
